import legacyColors from 'assets/theme/base/colors';
import legacyBoxShadows from 'assets/theme/base/boxShadows';
import legacyBorders from 'assets/theme/base/borders';
import legacyTypography from 'assets/theme/base/typography';
import boxShadow from "assets/theme/functions/boxShadow";
import hexToRgb from "assets/theme/functions/hexToRgb";
import linearGradient from "assets/theme/functions/linearGradient";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

export default function injectLegacyTheme(themeOptions) {
  themeOptions.boxShadows = { ...themeOptions.boxShadows, ...legacyBoxShadows };
  themeOptions.borders = { ...themeOptions.borders, ...legacyBorders };
  themeOptions.functions = {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  };
  
  // Safe palette injections into colorSchemes for MUI CSS Variables
  const paletteTarget = themeOptions.colorSchemes?.light?.palette;
  if (paletteTarget) {
    paletteTarget.gradients = legacyColors.gradients;
    paletteTarget.white = legacyColors.white;
    paletteTarget.transparent = legacyColors.transparent;
    paletteTarget.dark = { ...legacyColors.dark, ...paletteTarget.dark };
    paletteTarget.light = legacyColors.light;
    paletteTarget.badgeColors = legacyColors.badgeColors;
    paletteTarget.coloredShadows = legacyColors.coloredShadows;
    
    if (!paletteTarget.info) paletteTarget.info = {};
    paletteTarget.info = { ...legacyColors.info, ...paletteTarget.info };
    
    if (!paletteTarget.success) paletteTarget.success = {};
    paletteTarget.success = { ...legacyColors.success, ...paletteTarget.success };
    
    if (!paletteTarget.warning) paletteTarget.warning = {};
    paletteTarget.warning = { ...legacyColors.warning, ...paletteTarget.warning };

    if (!paletteTarget.error) paletteTarget.error = {};
    paletteTarget.error = { ...legacyColors.error, ...paletteTarget.error };
  }

  // Also inject into the root palette so that it's accessible directly via theme.palette
  if (themeOptions.palette) {
    themeOptions.palette.gradients = legacyColors.gradients;
    themeOptions.palette.white = legacyColors.white;
    themeOptions.palette.transparent = legacyColors.transparent;
    themeOptions.palette.dark = { ...legacyColors.dark, ...themeOptions.palette.dark };
    themeOptions.palette.light = legacyColors.light;
    themeOptions.palette.badgeColors = legacyColors.badgeColors;
    themeOptions.palette.coloredShadows = legacyColors.coloredShadows;
    
    if (!themeOptions.palette.info) themeOptions.palette.info = {};
    themeOptions.palette.info = { ...legacyColors.info, ...themeOptions.palette.info };
    
    if (!themeOptions.palette.success) themeOptions.palette.success = {};
    themeOptions.palette.success = { ...legacyColors.success, ...themeOptions.palette.success };
    
    if (!themeOptions.palette.warning) themeOptions.palette.warning = {};
    themeOptions.palette.warning = { ...legacyColors.warning, ...themeOptions.palette.warning };

    if (!themeOptions.palette.error) themeOptions.palette.error = {};
    themeOptions.palette.error = { ...legacyColors.error, ...themeOptions.palette.error };
  }

  // Some components might use legacy typography weights
  if (!themeOptions.typography) themeOptions.typography = {};
  themeOptions.typography.size = legacyTypography.size;
  themeOptions.typography.fontWeightLight = legacyTypography.fontWeightLight;
  themeOptions.typography.fontWeightRegular = legacyTypography.fontWeightRegular;
  themeOptions.typography.fontWeightMedium = legacyTypography.fontWeightMedium;
  themeOptions.typography.fontWeightBold = legacyTypography.fontWeightBold;
  
  return themeOptions;
}
